import {tr} from "../common/trans"
import {phrases} from "./phrases_pricing"

export const trans = (key: string, variables: any = null, formatter = null) => tr(phrases.messages, key, variables, formatter, true)

export const isTrans = (key) => {
    return phrases && phrases[key] !== undefined
}

export default trans